import { createResource, Suspense } from "solid-js";
import { A } from "@solidjs/router";
import { CircularProgress, Container, Paper, Typography, Button } from "@suid/material";
import { getCurrentUser, hasRole } from "../auth.js";

const RoleGuard = (props) => {
  const [user] = createResource(getCurrentUser);

  return (
    <Suspense
      fallback={
        <Container sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
          <CircularProgress />
        </Container>
      }
    >
      {user() && hasRole(user(), props.requiredRole) ? (
        props.children
      ) : (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
          <Paper sx={{ p: 4, textAlign: "center" }}>
            <Typography variant="h4" gutterBottom>
              Access Denied
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
              You do not have access to this page. The "{props.requiredRole}" role is required.
            </Typography>
            <Button component={A} href="/dashboard" variant="contained">
              Back to Dashboard
            </Button>
          </Paper>
        </Container>
      )}
    </Suspense>
  );
};

export default RoleGuard;
